import React, { useCallback } from 'react';

import { TouchableOpacity, View } from 'react-native';

import { useTranslation } from 'react-i18next';

import { ManageRecordingItem } from 'screens/Detail/types';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

type Props = {
    item: ManageRecordingItem;
    onPress?(item: ManageRecordingItem): void;
};

function SelectionOption({ item, onPress }: Props) {
    const { t } = useTranslation();

    const handlePress = useCallback(() => {
        if (onPress) {
            onPress(item);
        }
    }, [item, onPress]);

    return (
        <TouchableOpacity
            style={styles.container}
            activeOpacity={0.5}
            accessibilityRole="button"
            onPress={handlePress}
        >
            <View style={styles.wrapperContent}>
                <Text
                    category={ETextCategory.body1}
                    color={ETextColor.light_grey}
                >
                    {t(item.label)}
                </Text>
            </View>
        </TouchableOpacity>
    );
}

export default SelectionOption;
